import { onlyRedirectArgsConfig } from '../../../utils/event_constants';

export const verify2FAData = [
  {
    name: 'verifyTwoFactorAuthentication',
    label: 'Verify 2F Authentication',
    args: [
      onlyRedirectArgsConfig,
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
